export const ReportFields = {
  Report: {
    fieldKey: "ReportFormReport",
    element: "select",
    selectList: [
      {
        constKey: "report-fields-report-offensive-content-select-list",
        value: "Offensive Content",
      },
      {
        constKey: "report-fields-report-copy-right-infringement-select-list",
        value: "Copywrite Infringement",
      },
    ],
    defaultValue: {
      constKey: "select-topic",
      value: null,
    },
    title: "Report",
    label: "Report",
    fieldName: "ContactMessage",
    validation: {
      required: true,
    },
  },
  Email: {
    element: "input",
    fieldKey: "ReportFormEmail",
    type: "email",
    title: "Email",
    placeholder: "your-email",
    validation: {
      required: true,
      invalidMessage: "invalid-email-text",
      reg: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    },
  },
  Message: {
    element: "textarea",
    fieldKey: "ReportFormMessage",
    type: "string",
    title: "Message",
    placeholder: "write-here",
    validation: {
      required: true,
      invalidMessage: "invalid-textarea-text",
    },
  },
};
